const path = require("path");
const sprintf = require("i18next-sprintf-postprocessor");
const ns = require("./public/locales/namespaces");

const {
  locales,
  defaultLocale,
  isUsLaunchEnabled,
} = require("./config/locales");
const { formatMoney } = require("./config/price-format");

/**
 * `{{price, currency}}` in translation strings. Same formatter as app code
 * (config/price-format.js), so both produce the same text. A `place` on the
 * value (`withPricePlace`) and per-string `prefix` / `suffix` overrides still
 * apply.
 */
const format = (value, format, lng) => {
  if (
    format !== "currency" ||
    typeof value?.amount !== "number" ||
    !value?.currency
  ) {
    return value;
  }

  return formatMoney(value.amount, {
    locale: lng,
    currency: value.currency,
    place: value.place,
    prefix: value.prefix,
    suffix: value.suffix,
  });
};

module.exports = /** @type {const} */ ({
  i18n: {
    defaultLocale,
    locales,
    /*
     * WHO-5766: with `/en-us` routed, Next's own detection would send every
     * browser set to US English from `/` to `/en-us`, Europeans included. It
     * goes off together with the locale; `config/redirects.js`
     * (`languageDetectionRedirects`) keeps sending `/` to the five other
     * languages as Next did, and nothing ever redirects to `/en-us` (the
     * "Shopping from the US?" banner suggests it instead). Flag off: Next's
     * detection, as before.
     */
    ...(isUsLaunchEnabled() ? { localeDetection: false } : {}),
  },
  postProcess: "sprintf",
  returnNull: false,
  fallbackLng: false,
  // debug: true,
  /*
   * WHO-6644. `useLogMissingKeys` reports raw keys from i18next's `missingKey`
   * event, which i18next emits only with `saveMissing` on; that report had
   * never fired. On in the browser only, where the report runs.
   * `missingKeyHandler` must stay: without one, i18next "saves" a missing key
   * by writing the raw key into the store, which leaves exactly the kind of
   * partial namespace this ticket fixed.
   */
  saveMissing: typeof window !== "undefined",
  missingKeyHandler: () => {},
  ns,
  localePath: path.resolve("./public/locales"),
  serializeConfig: false,
  use: [sprintf],
  interpolation: {
    format,
  },
});
